// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
.text-overflow__qvrGu {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.text-gradient__KJx6O {
  background-image: -webkit-gradient(linear, 37.219838% 34.532506%, 36.425669% 93.178216%, from(#29cdff), to(#0a60ff), color-stop(0.37, #148eff));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.background-hover__OPQ_X {
  transition: all 0.3s ease-out;
}
.background-hover__OPQ_X:hover {
  background-color: #f9f9fc;
}
.header__fsQ8l {
  padding: 0;
  box-shadow: 4px 4px 40px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 72px;
  z-index: 9;
  align-items: center;
  background-color: #fff;
  padding-left: 0px;
  padding-right: 0px;
}
.header__fsQ8l.fixed__R2Q5z {
  position: fixed;
  top: 0;
  right: 0;
  width: calc(100% - 256px);
  z-index: 29;
  transition: width 0.2s;
}
.header__fsQ8l.fixed__R2Q5z.collapsed__zdQEd {
  width: calc(100% - 80px);
}
.header__fsQ8l .ant-menu-submenu-title {
  height: 72px;
}
.header__fsQ8l .ant-menu-horizontal {
  line-height: 72px;
}
.header__fsQ8l .ant-menu-horizontal > .ant-menu-submenu:hover {
  color: #e61e1e;
  background-color: #f9f9fc;
}
.header__fsQ8l .ant-menu {
  border-bottom: none;
  height: 72px;
}
.header__fsQ8l .ant-menu-horizontal > .ant-menu-submenu {
  top: 0;
  margin-top: 0;
}
.header__fsQ8l .ant-menu-horizontal > .ant-menu-item,
.header__fsQ8l .ant-menu-horizontal > .ant-menu-submenu {
  border-bottom: none;
}
.header__fsQ8l .ant-menu-horizontal > .ant-menu-item-active,
.header__fsQ8l .ant-menu-horizontal > .ant-menu-item-open,
.header__fsQ8l .ant-menu-horizontal > .ant-menu-item-selected,
.header__fsQ8l .ant-menu-horizontal > .ant-menu-item:hover,
.header__fsQ8l .ant-menu-horizontal > .ant-menu-submenu-active,
.header__fsQ8l .ant-menu-horizontal > .ant-menu-submenu-open,
.header__fsQ8l .ant-menu-horizontal > .ant-menu-submenu-selected,
.header__fsQ8l .ant-menu-horizontal > .ant-menu-submenu:hover {
  border-bottom: none;
}
.header__fsQ8l .rightContainer__XmAfD {
  display: flex;
  align-items: center;
  margin-right: 8px;
}
.header__fsQ8l .button__iCMmR {
  width: 72px;
  height: 72px;
  line-height: 72px;
  text-align: center;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease-out;
}
.header__fsQ8l .button__iCMmR:hover {
  color: #e61e1e;
  background-color: #f9f9fc;
}
@media (max-width: 767px) {
  .header__fsQ8l {
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.module.less","webpack://./src/Themes/mixin.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;ACO7F;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;ADLF;ACQA;EACE,+IAAA;EAQA,6BAAA;EACA,oCAAA;ADbF;ACgBA;EACE,6BAAA;ADdF;ACeE;EACE,yBAAA;ADbJ;AAhBA;EACE,UAAA;EACA,8CAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAkBF;AAhBE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AAkBJ;AAhBI;EACE,wBAAA;AAkBN;AAxCA;EA4BM,YAAA;AAeN;AA3CA;EAgCM,iBAAA;AAcN;AAZM;EACE,cAAA;EACA,yBAAA;AAcR;AAlDA;EAyCM,mBAAA;EACA,YAAA;AAYN;AAtDA;EA8CM,MAAA;EACA,aAAA;AAWN;AA1DA;;EAoDM,mBAAA;AAUN;AA9DA;;;;;;;;EA+DM,mBAAA;AASN;AAxEA;EAsEI,aAAA;EACA,mBAAA;EACA,iBAAA;AAKJ;AA7EA;EA4EI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,6BAAA;AAIJ;AAFI;EACE,cAAA;EACA,yBAAA;AAIN;AAEA;EACE;IACE,sBAAA;EAAF;AACF","sourcesContent":["@import '../../Themes/vars.less';\n\n\n.header {\n  padding: 0;\n  box-shadow: @shadow-2;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  height: 72px;\n  z-index: 9;\n  align-items: center;\n  background-color: #fff;\n  padding-left: 0px;\n  padding-right: 0px;\n\n  &.fixed {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: ~'calc(100% - 256px)';\n    z-index: 29;\n    transition: width 0.2s;\n\n    &.collapsed {\n      width: ~'calc(100% - 80px)';\n    }\n  }\n\n  :global {\n    .ant-menu-submenu-title {\n      height: 72px;\n    }\n\n    .ant-menu-horizontal {\n      line-height: 72px;\n\n      & > .ant-menu-submenu:hover {\n        color: @primary-color;\n        background-color: @hover-color;\n      }\n    }\n\n    .ant-menu {\n      border-bottom: none;\n      height: 72px;\n    }\n\n    .ant-menu-horizontal > .ant-menu-submenu {\n      top: 0;\n      margin-top: 0;\n    }\n\n    .ant-menu-horizontal > .ant-menu-item,\n    .ant-menu-horizontal > .ant-menu-submenu {\n      border-bottom: none;\n    }\n\n    .ant-menu-horizontal > .ant-menu-item-active,\n    .ant-menu-horizontal > .ant-menu-item-open,\n    .ant-menu-horizontal > .ant-menu-item-selected,\n    .ant-menu-horizontal > .ant-menu-item:hover,\n    .ant-menu-horizontal > .ant-menu-submenu-active,\n    .ant-menu-horizontal > .ant-menu-submenu-open,\n    .ant-menu-horizontal > .ant-menu-submenu-selected,\n    .ant-menu-horizontal > .ant-menu-submenu:hover {\n      border-bottom: none;\n    }\n  }\n\n  \n\n  .rightContainer {\n    display: flex;\n    align-items: center;\n    margin-right: 8px;\n  }\n\n  .button {\n    width: 72px;\n    height: 72px;\n    line-height: 72px;\n    text-align: center;\n    font-size: 18px;\n    cursor: pointer;\n    transition: @transition-ease-in;\n\n    &:hover {\n      color: @primary-color;\n      background-color: @hover-color;\n    }\n  }\n}\n\n\n@media (max-width: 767px) {\n  .header {\n    width: 100% !important;\n  }\n}","@import './default.less'; \n\n@dark-half: #494949;\n@purple: #d897eb;\n@shadow-1: 4px 4px 20px 0 rgba(0, 0, 0, 0.01);\n@shadow-2: 4px 4px 40px 0 rgba(0, 0, 0, 0.05);\n@transition-ease-in: all 0.3s ease-out;\n@transition-ease-out: all 0.3s ease-out;\n@ease-in: ease-in;\n\n.text-overflow {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.text-gradient {\n  background-image: -webkit-gradient(\n    linear,\n    37.219838% 34.532506%,\n    36.425669% 93.178216%,\n    from(#29cdff),\n    to(#0a60ff),\n    color-stop(0.37, #148eff)\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.background-hover {\n  transition: @transition-ease-in;\n  &:hover {\n    background-color: @hover-color;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text-overflow": `text-overflow__qvrGu`,
	"text-gradient": `text-gradient__KJx6O`,
	"background-hover": `background-hover__OPQ_X`,
	"header": `header__fsQ8l`,
	"fixed": `fixed__R2Q5z`,
	"collapsed": `collapsed__zdQEd`,
	"rightContainer": `rightContainer__XmAfD`,
	"button": `button__iCMmR`
};
export default ___CSS_LOADER_EXPORT___;
